module.exports = __webpack_public_path__ + "static/media/direct-inbox.bc872a9c.svg";